import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./contexts/UserContext";
import { TrailProvider } from "./contexts/TrailContext";
import { AllTrailsProvider } from "./contexts/AllTrailsContext";
import ErrorComponent from "./components/ErrorComponent/ErrorComponent";

ReactDOM.render(
  <BrowserRouter>
    <TrailProvider>
      <AllTrailsProvider>
        <UserProvider>
          <ErrorComponent>
            <App />
          </ErrorComponent>
        </UserProvider>
      </AllTrailsProvider>
    </TrailProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
